import { Link, useNavigate, useParams } from '@tanstack/react-router';
import { CircleArrowLeft, Loader2 } from 'lucide-react';

import { useGetAnnouncement } from '~entities/announcements';

import { AnnouncementForm } from './announcement-form';

export function UpdateAnnouncementPage() {
  const { announcementId } = useParams({
    from: '/_auth/_layout/announcements/$announcementId/',
  });
  const navigate = useNavigate({ from: '/announcements/$announcementId' });
  const { data, isLoading, isError } = useGetAnnouncement(announcementId);

  return (
    <div className='pb-56'>
      <Link to='/announcements' className='flex items-center gap-2'>
        <CircleArrowLeft className='size-6' />
        <h2 className='text-2xl font-semibold'>Edit announcement</h2>
      </Link>
      <div className='mt-6'>
        {isLoading && (
          <div className='flex justify-center py-12'>
            <Loader2 className='size-8 animate-spin text-muted-foreground' />
          </div>
        )}
        {isError && (
          <p className='text-sm text-destructive'>
            Unable to load announcement.
          </p>
        )}
        {data && (
          <AnnouncementForm
            announcement={data}
            onSuccess={() => {
              void navigate({ to: '/announcements' });
            }}
          />
        )}
      </div>
    </div>
  );
}
